import React from "react"
import { ResponsiveContainer, XAxis, YAxis, Tooltip, LineChart, Line, Legend } from "recharts"
import moment from "moment-timezone"

import { Loading } from "@common/EcosuiteComponent"
import { GRAPH_COLORS } from "@common/module/EcosuiteView"
import EnergyUtils from "@dashboard/energy/EnergyUtils"
import DateRangeGraph from "../DateRangeGraph"
import GraphUtils from "@common/utils/GraphUtils"
import i18n from "src/i18n"

const { t } = i18n
export default class EcosuiteForecastGenerationLineGraph extends DateRangeGraph {
  getData() {
    let data = Object.keys(this.props.graphDatums).map((dateKey) => {
      let datum = this.props.graphDatums[dateKey]
      let date = moment(dateKey)
      let entry = {
        date: date.toDate(),
        time: date.toDate().getTime(),
        name: date.format("lll"),
      }

      Object.keys(datum.assetDatums).forEach((assetCode) => {
        entry[assetCode] = this.round(datum.assetDatums[assetCode].generation)
        entry[assetCode + " (Ecosuite Forecast)"] = this.round(datum.assetDatums[assetCode].forecastGeneration)
        entry[assetCode + " (+12 Forecast)"] = this.round(datum.assetDatums[assetCode].forecast12Generation)
        entry[assetCode + " (+24 Forecast)"] = this.round(datum.assetDatums[assetCode].forecast24Generation)
        entry[assetCode + " (+48 Forecast)"] = this.round(datum.assetDatums[assetCode].forecast48Generation)
      })

      return entry
    })
    return data
  }

  renderContent() {
    if (this.props.graphDatums && this.props.datums) {
      let data = this.getData()
      let aggregation = this.props.aggregation
      let graphType = aggregation === "day" ? "linear" : "monotone"
      const legendCount = this.props.assets.length * 5 // Each asset has 5 lines: actual + 4 forecasts

      return (
        <ResponsiveContainer width="100%" height={GraphUtils.getGraphHeight(legendCount)}>
          <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 10 }} onClick={this.zoomDateRange}>
            <XAxis
              dataKey="time"
              type="number"
              scale="time"
              domain={this.getDomain(this.props.range, this.props.aggregation)}
              tickFormatter={(time) => {
                return GraphUtils.dateFormat(time, this.props.range, this.props.aggregation)
              }}
            />
            <YAxis />

            <Tooltip
              wrapperStyle={{ color: "#000", pointerEvents: "auto" }}
              // eslint-disable-next-line no-unused-vars
              formatter={(value, name, props) => {
                if (this.props.normalise) {
                  return value
                }
                return EnergyUtils.formatKiloWattHours(value)
              }}
              labelFormatter={(label) => {
                return GraphUtils.formatDateTooltip(label, this.props.range, this.props.aggregation)
              }}
            />
            <Legend iconType="plainline" />

            {this.props.assets.map((asset, idx) => {
              return (
                <Line
                  key={idx}
                  type={graphType}
                  dataKey={asset.code}
                  stroke={GRAPH_COLORS[0]}
                  dot={aggregation === "day"}
                  strokeWidth={2}
                />
              )
            })}

            {this.props.assets.map((asset, idx) => {
              return (
                <Line
                  key={idx + "-forecast"}
                  type={graphType}
                  dataKey={asset.code + ` (${t("energy.labels.ecosuite_forecast")})`}
                  stroke={GRAPH_COLORS[1]}
                  dot={aggregation === "day"}
                  strokeDasharray="10 2"
                  strokeWidth={1}
                />
              )
            })}

            {this.props.assets.map((asset, idx) => {
              return (
                <Line
                  key={idx + "-12"}
                  type={graphType}
                  dataKey={asset.code + " (+12 Forecast)"}
                  stroke={GRAPH_COLORS[2]}
                  dot={aggregation === "day"}
                  strokeDasharray="6 3"
                  strokeWidth={1}
                />
              )
            })}

            {this.props.assets.map((asset, idx) => {
              return (
                <Line
                  key={idx + "-24"}
                  type={graphType}
                  dataKey={asset.code + " (+24 Forecast)"}
                  stroke={GRAPH_COLORS[3]}
                  dot={aggregation === "day"}
                  strokeDasharray="4 4"
                  strokeWidth={1}
                />
              )
            })}

            {this.props.assets.map((asset, idx) => {
              return (
                <Line
                  key={idx + "-48"}
                  type={graphType}
                  dataKey={asset.code + " (+48 Forecast)"}
                  stroke={GRAPH_COLORS[4]}
                  dot={aggregation === "day"}
                  strokeDasharray="2 6"
                  strokeWidth={1}
                />
              )
            })}
            {this.renderCurrentTime()}
          </LineChart>
        </ResponsiveContainer>
      )
    }

    return <Loading />
  }
}
